import React, { useState } from "react";
import { Spinner, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import api from "../../services/client/api";
import { useHistory } from "react-router-dom";
import { deleteCookies } from "../../utils/functions";

export default function ListArquives({ reports, month, year, token }) {
  const [downloading, setDownloading] = useState(false);
  const history = useHistory();

  const getMonthName = (month) => {
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];
    return months[month - 1];
  };

  const download = async () => {
    setDownloading(true);

    try {
      // agora você envia apenas mês e ano

      const response = await api().file().download(token, month, year, reports);

      if (response.status === 401) {
        await deleteCookies();
        history.replace({ pathname: "/doctor" });
        return;
      }

      if (response.status === 200) {
        const blob = new Blob([response.output], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = `relatorio_${year}_${month}.xlsx`;

        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Erro ao baixar Excel:", error);
    }

    setDownloading(false);
  };

  if (!reports || reports.length === 0) {
    return null;
  }

  return (
    <tr>
      <td style={{ textAlign: "center", color: "#0C2B6E", fontWeight: 600 }}>
        {getMonthName(month)} - {year}
      </td>

      <td style={{ textAlign: "center" }}>{reports.length}</td>

      <td style={{ textAlign: "center" }}>
        <Button color="primary" disabled={downloading} onClick={download}>
          {downloading ? (
            <>
              <Spinner size="sm" /> Gerando...
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faDownload} /> Download Excel
            </>
          )}
        </Button>
      </td>
    </tr>
  );
}
